<template>
  <div>
    <van-popup
      v-model="show"
      class="full-height full-width"
      :close-on-popstate="true"
      position="right"
    >
      <ld-header @click-left="show = false">
        选择国家和地区
      </ld-header>
      <van-search
        v-model.lazy="value"
        placeholder="请输入中文/简拼/二字码"
        shape="round"
      />
      <van-cell-group>
        <van-cell
          v-for="(nation,index) in list"
          :key="index"
          :title="nation.cName"
          :value="nation.by3"
          clickable
          @click="select(nation)"
        />
      </van-cell-group>
    </van-popup>
  </div>
</template>

<script>
import { Search, Popup, Cell, CellGroup } from 'vant'

export default {
  name: 'LdNation',
  components: {
    [Popup.name]: Popup,
    [Search.name]: Search,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup
  },
  props: {},
  data() {
    return {
      show: false,
      value: '',
      nationList: [],
      list:[],
      iln:false
    }
  },
  created() {
    this.$api['common/getFindNationList']().then(res => {
      let cache=res.data||{}
      let list=cache.nations||[]
      if(list.length>0){
        this.nationList=list
      }
    })
  },
  methods: {
    select (nation) {
      this.show = false
      this.$emit('selected', nation,this.iln)

    },
    toggle(iln) {
      this.iln=iln
      this.show = !this.show
    }
  },
  watch:{
    value(val){
      if(val){
        const term = val.toUpperCase()
        this.list=this.nationList.filter(nation => {
          return (
            nation.by1 && nation.by1.indexOf(term) > -1 ||
                        nation.by3 && nation.by3.indexOf(term) > -1 ||
                        nation.cName && nation.cName.indexOf(term) > -1
          )
        })
      }else{
        this.list=this.nationList
      }
    },
    'nationList.length'(){
      this.list=this.nationList
    }
  }
}
</script>

<style lang="less" scoped>
</style>
